export default __webpack_public_path__ + "static/media/tiktok-brands.19903202.svg";